import { render, staticRenderFns } from "./yuanwenjiaoyan.vue?vue&type=template&id=3c0c9889&scoped=true&"
import script from "./yuanwenjiaoyan.vue?vue&type=script&lang=ts&"
export * from "./yuanwenjiaoyan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0c9889",
  null
  
)

export default component.exports